export const $: JQueryStatic<HTMLElement> = (window as any).jQuery || (window as any).$
